import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const SocialLinks = () => {
  const iconsRef = useRef([]);

  useEffect(() => {
    // GSAP entry animation
    gsap.from(iconsRef.current, {
      opacity: 0,
      y: 50,
      stagger: 0.2,
      duration: 2,
      ease: "power3.out",
    });
  }, []);

  const handleMouseEnter = (index) => {
    gsap.to(iconsRef.current[index], {
      scale: 1.2,
      duration: 1.3,
      ease: "power1.out",
    });
  };

  const handleMouseLeave = (index) => {
    gsap.to(iconsRef.current[index], {
      scale: 1,
      duration: 1.3,
      ease: "power1.out",
    });
  };

  return (
    <div className="links-position">
      <div className="header-content-info">
        {[
          {
            href: "https://github.com/khaledjafar",
            src: "./images/icons8-github-100.png",
            alt: "GitHub",
          },
          {
            href: "https://www.linkedin.com/in/khaled-jafar-abu-ijdea-a-547483274/",
            src: "./images/icons8-linkedin-100.png",
            alt: "LinkedIn",
          },
          {
            href: "https://www.instagram.com/khaled__jafar/",
            src: "./images/icons8-instagram-100.png",
            alt: "Instagram",
          },
          {
            href: "https://www.linkedin.com/feed/update/urn:li:activity:7284696134600511489/",
            src: "./images/icons8-resume-50.png",
            alt: "Resume",
          },
        ].map((link, index) => (
          <a
            key={index}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            ref={(el) => (iconsRef.current[index] = el)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave(index)}
          >
            <img src={link.src} alt={link.alt} className="icons" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;
